/**
 * Runs function after the current code has been executed
 * @param callback `() => void`
 */
export default function runLater(callback) {
    setTimeout(callback, 1);
}
